import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppointmentTypeService, AvailabilityService, OrganizationService } from './services';
import { AppointmentsService } from './services/appointments.service';

const angularModules = [CommonModule];
const thirdPartyModules = [];

const services = [
  AppointmentsService,
  AppointmentTypeService,
  AvailabilityService,
  OrganizationService
];

const guards = [];
const sharedComponents = [];
const pipes = [];

@NgModule({
  imports: [
    ...angularModules,
    ...thirdPartyModules
  ],
  exports: [
    ...angularModules,
    ...thirdPartyModules,
    ...sharedComponents,
    ...pipes
  ],
  declarations: [
    ...sharedComponents,
    ...pipes,

  ],
  providers: [
    ...services,
    ...guards
  ]
})
export class WelcomeModule { }
